export default __webpack_public_path__ + "static/media/Tu_Billetera_Disable.4e47d1d4.svg";